import React, { useState, useEffect } from "react";
import "../../assets/vendors/mdi/css/materialdesignicons.min.css"; // Import the Material Design Icons
import Cookies from "js-cookie";
import { useRole } from "../contextApi/RoleContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProfileImg from "../common/ProfileImg";
import { useNavigate } from "react-router-dom";
import logo from "../images/images.png";
import { API } from "../../helper/Api";

const AccountPage = () => {
  const API_URL = process.env.REACT_APP_BASE_URL;
  const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;
  const {
    setRole,
    role,
    setPermission,
    permission,
    setUserDetails,
    userDetails,
  } = useRole();
  const navigate = useNavigate();
  const [username, setUsername] = useState(Cookies.get("username"));
  const [loginId, setLoginId] = useState(Cookies.get("loginid"));
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [showPasswordResetModal, setShowPasswordResetModal] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState(""); // State for message
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const [err, setErr] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [shakeName, setShakeName] = useState(false); // State for username shake
  const [is2FAEnabled, setIs2FAEnabled] = useState(false); // State for 2FA checkbox
  const [errors, setErrors] = useState("");
  const [profileImage, setProfileImage] = useState(logo);

  useEffect(() => {
    console.log("check login id", loginId);
    if (loginId) {
      fetchDataUser(loginId);
    }
    // setUsername(Cookies.get("username"));
    // setLoginId(Cookies.get("loginid"));
    // if (userDetails.twofactor_auth === "1") {
    //   setIs2FAEnabled(true);
    // }
    // console.log("check account details here", userDetails);
  }, []);

  // Define fetchuser by id
  const fetchDataUser = async (id) => {
    try {
      const res = await API.accessSetting("getrolebyid", id);
      if (res.success) {
        // setGetRoles(res.content);
        //  console.log("roles are here", res);
        res.content.map((item) => {
          if (item.twofactor_auth === "1") {
            setIs2FAEnabled(true);
          }
          if (item.profileimg_url !== "") {
            setProfileImage(`${IMAGE_URL}${item.profileimg_url}`);
          }
        });
        // handle response if needed
      } else {
        console.log("Error in fetching roles");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSave = async () => {
    // Logic to save changes, including the 2FA status
    try {
      const getRes = await fetch(`${API_URL}myAccount.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set content type to JSON
        },
        body: JSON.stringify({
          twoFactor: is2FAEnabled,
          userName: username,
          loginId: Number(loginId),
          type: "accountSave",
        }),
      });
      const output = await getRes.json();
      if (output.success) {
        toast.success("Account updated successfully!", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
      } else {
        toast.error("Account update failed! Please try again.", {
          position: "top-center",
          autoClose: false,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
          className: "login-toast",
        });
      }
    } catch (err) {
      console.error("error in account page", err);
    }
  };

  const handlePasswordReset = () => {
    setNewPassword("");
    setCurrentPassword("");
    setConfirmPassword("");
    setErrors("");
    setErr("");
    setShowPasswordResetModal(true);
  };

  const passwordHandle = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setErr("");
    // Define validation criteria
    const validations = {
      length: value.length >= 8,
      specialChar: /[@$!%*?&]/.test(value),
      uppercase: /[A-Z]/.test(value),
      number: /\d/.test(value),
    };

    // Check if all validations pass
    const allValid = Object.values(validations).every(Boolean);

    if (allValid) {
      setErrors({});
    } else {
      // Create feedback messages
      const feedback = {
        length: validations.length
          ? "Password length is sufficient"
          : "Password must be at least 8 characters long",
        specialChar: validations.specialChar
          ? "Special character included"
          : "Include at least one special character",
        uppercase: validations.uppercase
          ? "Uppercase letter included"
          : "Include at least one uppercase letter",
        number: validations.number
          ? "Number included"
          : "Include at least one number",
      };
      setErrors(feedback);
    }
  };

  const handlePasswordChange = () => {
    if (newPassword.trim() === "") {
      setErr((prev) => ({ ...prev, newPassword: "(Password is required)" }));
    }
    if (Object.entries(errors).length !== 0) {
      setErr("");
    }
    if (currentPassword.trim() === "") {
      setErr((prev) => ({
        ...prev,
        currentPassword: "(Current Password is required)",
      }));
    } else {
      if (confirmPassword.trim() === newPassword.trim()) {
        setPassword(newPassword);
        // Call the API to reset the password
        fetch(`${API_URL}myAccount.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set content type to JSON
          },
          body: JSON.stringify({
            newPassword: newPassword,
            currentPassword: currentPassword,
            userName: username,
            loginId: Number(loginId),
            type: "passwordChange",
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            if (data.success === true) {
              toast.success("Password updated successfully!", {
                position: "top-center",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
                className: "login-toast",
              });
              setShowPasswordResetModal(false);
              setErr(""); // Clear any previous errors
            } else {
              if (data.message) {
                toast.error("Incorrect current password.", {
                  position: "top-center",
                  autoClose: false,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                  className: "login-toast",
                });
              } else {
                toast.error("Password update failed! Please try again.", {
                  position: "top-center",
                  autoClose: false,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "colored",
                  className: "login-toast",
                });
              }
            }
          })
          .catch((error) => {
            setAlertMessage("An error occurred. Please try again.");
            setAlertVisible(true);
            setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
            console.error("Error:", error);
          });
      } else {
        setErr((prev) => ({
          ...prev,
          confirmPassword: "(Passwords do not match..)",
        }));
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginLeft: "4px",
  };

  return (
    <div className="container-fluid page-body-wrapper">
      {/* Add the Shake Keyframe Animation */}
      <ToastContainer
        position="top-center"
        autoClose={500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="main-panel">
        <div className="content-wrapper">
          {/* <div className="row justify-content-center">
            <div className="col-md-6 contents">User Profile</div>
            <div className="col-md-6">test</div>
          </div> */}
          <div className="row justify-content-center">
            <div className="col-md-6 contents">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <div
                    // className="form-block"
                    style={{
                      backgroundColor: "white",
                      // padding: "2rem",
                      borderRadius: "8px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "22px",
                        color: "#062b44",
                        paddingTop: "8px",
                        marginLeft: "20px",
                      }}
                    >
                      User Profile
                    </div>
                    <hr style={{ marginTop: "10px" }}></hr>
                    <div className="accbody">
                      {alertVisible && (
                        <div
                          style={{
                            marginBottom: "1rem",
                            padding: "1rem",
                            backgroundColor: alertMessage.includes("failed")
                              ? "#dc3545"
                              : "#28a745",
                            color: "white",
                            borderRadius: "5px",
                            textAlign: "center",
                          }}
                        >
                          {alertMessage}
                        </div>
                      )}
                      <div className="profilecontent">
                        <div>
                          <ProfileImg
                            profileImage={profileImage}
                            setProfileImage={setProfileImage}
                          />
                        </div>
                        <div>
                          <div
                            style={{
                              marginTop: "14px",
                              color: "#062b44",
                              fontSize: "17px",
                            }}
                          >
                            {username}
                          </div>
                          <button
                            onClick={handlePasswordReset}
                            className="changepassword"
                          >
                            <i
                              className="mdi mdi mdi-lock"
                              style={{ marginRight: "2px" }}
                            ></i>
                            CHANGE PASSWORD
                          </button>
                        </div>
                      </div>
                      {/* 2FA Checkbox */}
                      <div className="mb-4 mt-4">
                        <input
                          type="checkbox"
                          id="twoFactor"
                          checked={is2FAEnabled}
                          onChange={() => setIs2FAEnabled(!is2FAEnabled)}
                          style={{
                            marginLeft: "10px",
                            transform: "scale(1.3)",
                            width: "20px",
                          }}
                        />
                        <label
                          htmlFor="twoFactor"
                          style={{
                            fontSize: "14px",
                            color: "#555",
                            marginLeft: "6px",
                          }}
                        >
                          Two Factor Authentication
                        </label>
                      </div>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <button
                          onClick={() => {
                            navigate("/");
                          }}
                          className="cancelacc"
                        >
                          CANCEL
                        </button>
                        <button onClick={handleSave} className="accountsave">
                          <i
                            className="mdi mdi-content-save"
                            style={{ marginRight: "2px" }}
                          ></i>{" "}
                          SAVE
                        </button>
                      </div>
                    </div>
                    {/* Modal for password reset */}
                    {showPasswordResetModal && (
                      <div
                        style={{
                          position: "fixed",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%",
                          padding: "20px",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        onClick={() => setShowPasswordResetModal(false)}
                      >
                        <div
                          style={{
                            backgroundColor: "white",
                            // padding: "2rem",
                            borderRadius: "8px",
                            width: "500px",
                            marginTop: "40px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                          onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking inside
                        >
                          <div
                            style={{ paddingTop: "15px", marginLeft: "13px" }}
                          >
                            Change Password
                          </div>
                          <hr
                          // style={{ width: "503px", marginLeft: "-34px" }}
                          ></hr>
                          <div style={{ padding: "1rem" }}>
                            <div className="mb-4">
                              <label htmlFor="currentPassword">
                                Current Password:{" "}
                                {err.currentPassword && (
                                  <span style={invalidFeedbackStyle}>
                                    {err.currentPassword}
                                  </span>
                                )}{" "}
                              </label>
                              <input
                                type="password"
                                id="currentPassword"
                                placeholder="Current Password"
                                value={currentPassword}
                                onChange={(e) =>
                                  setCurrentPassword(e.target.value)
                                }
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  fontSize: "14px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  backgroundColor: "#f1f1f1",
                                  marginBottom: "1rem",
                                  color: "#555",
                                }}
                              />
                              <label
                                htmlFor="newPassword"
                                style={{ fontSize: "14px", color: "#555" }}
                              >
                                New Password:
                                {err.newPassword && (
                                  <span style={invalidFeedbackStyle}>
                                    {err.newPassword}
                                  </span>
                                )}{" "}
                              </label>

                              <input
                                type="password"
                                id="newPassword"
                                placeholder="Password"
                                value={newPassword}
                                onChange={passwordHandle}
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  fontSize: "14px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  backgroundColor: "#f1f1f1",
                                  marginBottom: "1rem",
                                  color: "#555",
                                }}
                              />
                              {errors && (
                                <div style={invalidFeedbackStyle}>
                                  {Object.entries(errors).map(
                                    ([key, message]) => (
                                      <p
                                        key={key}
                                        style={{
                                          color:
                                            message.includes("included") ||
                                            message.includes("sufficient")
                                              ? "#0dc10d"
                                              : "red",
                                          margin: "5px 0",
                                        }}
                                      >
                                        {message}
                                      </p>
                                    )
                                  )}
                                </div>
                              )}
                              <label
                                htmlFor="confirmPassword"
                                style={{ fontSize: "14px", color: "#555" }}
                              >
                                Confirm Password:
                                {err.confirmPassword && (
                                  <span style={invalidFeedbackStyle}>
                                    {err.confirmPassword}
                                  </span>
                                )}{" "}
                              </label>

                              <input
                                type="password"
                                id="confirmPassword"
                                placeholder="Confirm Password"
                                value={confirmPassword}
                                onChange={(e) =>
                                  setConfirmPassword(e.target.value)
                                }
                                style={{
                                  width: "100%",
                                  padding: "8px",
                                  fontSize: "14px",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  backgroundColor: "#f1f1f1",
                                  marginBottom: "1rem",
                                  color: "#555",
                                }}
                              />
                            </div>
                            <div style={{ display: "flex", gap: "10px" }}>
                              <button
                                onClick={() => setShowPasswordResetModal(false)}
                                className="cancelacc"
                              >
                                CANCEL
                              </button>
                              <button
                                onClick={handlePasswordChange}
                                className="accountsave"
                              >
                                SAVE
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
